export const importFromFileEn = {
  importFromOtherServices: 'Import from other services',
  importFromXLSX: 'Import XLS/CSV file',
  importFromJsonFile: 'Import project from JSON file',
  import: 'Import',
  cancel: 'Cancel',
  proceed: 'Proceed',
  selectFile: 'Select CSV file for import',
  dragAndDrop: 'or drag and drop it to this area',
  unacceptableFileType: 'Unacceptable file type. Only CSV are allowed',
  finishDragAndDrop: 'drop file to start uploading',
  foundUnregisteredUsers: `Some users from this file have not been added to project.
    You can add them manually in My company page and start import again.
    There are a list of these users:`,
  importFinished: 'Import finished successfully.',
  projectCreated: 'Created project:',
  projectsCreated: 'Created projects:',
  descriptionOfProject: 'The name of the project to which the entry belongs',
  descriptionOfTitle: 'Column with task title',
  descriptionOfDescription: 'Task description',
  descriptionOfCreatedDate: 'Task created date',
  descriptionOfDeadline: 'Task deadline',
  descriptionOfStartDate: 'Task start date',
  descriptionOfCompleted: 'Task completed',
  descriptionOfArchived: 'Task archived',
  descriptionOfColumn: 'Column where task located',
  descriptionOfBoard: 'Board where task located',
  descriptionOfAssigned: 'E-mail of assigned user for this task',
  descriptionOfParentTask: 'Parent task',
  saveAndUpload: 'After that save file and upload here',
  columnNamesBellow: 'Bellow you can see names and types of columns',
  detected: 'detected',
  notDetected: 'not detected',
  fileTooLarge: 'Maximum allowed file size is',
  titleNotFound: 'Task title column was not found in your file',
  otherTasks: 'Other',
  projectImportInProgress: 'Project import in progress:',
  projectImportSuccess: 'project successfully imported',
  columnName: 'Name',
  requiredField: 'Required field',
  columnDescription: 'Description',
  columnType: 'Type',
  columnTypeString: 'String',
  columnTypeDate: 'Date',
  columnTypeEmail: 'Email',
  columnStatus: 'Status',
  newTextPart1:
    'In the first line of your file, you should title the columns with English words. If the name of your column does not match the list below, we will save the data and send it to the chat for the imported task.',
  newTextPart2:
    'If you want to add some parameters as stickers, you need to head the column in the following format: Sticker The name of the sticker. For example, Sticker Priority',
  newTextPart3: 'You can download an example CSV file',
  newTextPart4:
    'For a successful import, the file must meet the following requirements:',
  newTextPart5: '- UTF-8 encoding',
  newTextPart6:
    '- date format one of: YYYY-MM-DD, MM/DD/YYYY, DD.MM.YYYY, DD.MM.YY',
  newTextPart7:
    '- date format with time: DD.MM.YYYY hh:mm:ss, DD.MM.YYYY hh:mm',
  newTextPart8: '- a comma or a semicolon is used as a separator',
  newTextPart9: 'Column names for import:',
  templateImportFileLink: 'here. '
}

export const importFromFileRu: typeof importFromFileEn = {
  importFromOtherServices: 'Импортировать из других сервисов',
  importFromXLSX: 'Импортировать CSV файл',
  importFromJsonFile: 'Импорт проекта из JSON файла',
  import: 'Импортировать',
  selectFile: 'Выбрать CSV файл для импорта',
  dragAndDrop: 'или перетащите файл в эту область',
  unacceptableFileType: 'Недопустимый тип файла. Принимаются только CSV',
  finishDragAndDrop: 'отпустите для загрузки файла',
  cancel: 'Отмена',
  proceed: 'Продолжить',
  foundUnregisteredUsers: `В загруженных задачах есть исполнители, которых нет
    среди сотрудников вашей компании в YouGile.
    Вы можете добавить их, воспользовавшись функцией
    Импорт из списка на странице Моя компания -> Сотрудники компании ->
    Пригласить сотрудников.
    Также вы можете продолжить, не добавляя их. В таком случае, задачи будут
    без назначения пользователя.
    Вот список этих пользователей:`,
  importFinished: 'Импорт завершен успешно.',
  projectCreated: 'Создан проект:',
  projectsCreated: 'Созданы проекты:',
  descriptionOfProject: 'Название проекта, к которому относится запись',
  descriptionOfTitle: 'В столбце нужно указывать название задачи',
  descriptionOfDescription: 'Описание задачи',
  descriptionOfCreatedDate: 'Столбец c датой создания задачи',
  descriptionOfDeadline: 'Столбец c датой окончания дедлайна задачи',
  descriptionOfStartDate: 'Столбец c датой начала дедлайна задачи',
  descriptionOfCompleted: 'Столбец c "Задача выполнена"',
  descriptionOfArchived: 'Столбец c "Задача архивирована"',
  descriptionOfColumn: 'Столбец c колонкой в которой находится задача',
  descriptionOfBoard: 'Столбец c доской в которой находится задача',
  descriptionOfAssigned:
    'Столбец c e-mail пользователя, на которого назначена задача',
  descriptionOfParentTask: 'Столбец с задачей родителем (для подзадач)',
  saveAndUpload: 'После этого сохранить файл и загрузить сюда',
  columnNamesBellow: 'Ниже приведены названия колонок для импорта',
  detected: 'обнаружен',
  notDetected: 'не обнаружен',
  fileTooLarge: 'Максимально допустимый размер файла',
  titleNotFound: `Для импорта файла в нём должен быть как минимум столбец
    с названием задачи (Title)`,
  otherTasks: 'Остальное',
  projectImportInProgress: 'Импортируется проект',
  projectImportSuccess: 'проект успешно импортирован',
  columnName: 'Название',
  requiredField: 'Обязательное поле',
  columnDescription: 'Описание',
  columnType: 'Тип',
  columnTypeString: 'String',
  columnTypeDate: 'Date',
  columnTypeEmail: 'Email',
  columnStatus: 'Статус',
  newTextPart1:
    'В первой строке вашего файла вы должны озаглавить колонки английскими словами. Если название вашей колонки не будет соответствовать перечню ниже, мы сохраним данные и отправим их в чат к импортируемой задаче.',
  newTextPart2:
    'Если вы хотите добавить какие-то параметры в качестве стикеров, вам необходимо озаглавить столбец в следующем формате: Sticker Название стикера. Например, Sticker Приоритет',
  newTextPart3: 'Вы можете скачать пример CSV файла',
  newTextPart4:
    'Для успешного импорта файл должен отвечать следующим требованиям:',
  newTextPart5: '- кодировка UTF-8',
  newTextPart6:
    '- формат даты один из: YYYY-MM-DD, MM/DD/YYYY, DD.MM.YYYY, DD.MM.YY',
  newTextPart7:
    '- формат даты со временем: DD.MM.YYYY hh:mm:ss, DD.MM.YYYY hh:mm',
  newTextPart8:
    '- в качестве разделителя используется запятая или точка запятая',
  newTextPart9: 'Названия колонок для импорта:',
  templateImportFileLink: 'по ссылке. '
}
